var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.367,
    height: 24.367,
    viewBox: "0 0 24.367 24.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27383",
    "data-name": "Group 27383",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37928",
    "data-name": "Path 37928",
    d: "M42.447,160.625a11.688,11.688,0,0,1-19.937,0l9.969-5.755h0Z",
    transform: "translate(-20.796 -142.846)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37929",
    "data-name": "Path 37929",
    d: "M12.183.5V12.524L2.214,18.279A11.641,11.641,0,0,1,.5,12.183a11.744,11.744,0,0,1,.123-1.7A11.579,11.579,0,0,1,1.919,6.6,11.669,11.669,0,0,1,12.183.5Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37930",
    "data-name": "Path 37930",
    d: "M162.183,12.183a11.634,11.634,0,0,1-1.715,6.1L150.5,12.525V.5a11.676,11.676,0,0,1,11.683,11.683Z",
    transform: "translate(-138.817 -0.5)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpread);
export default __webpack_public_path__ + "static/media/spread.4eaf67a879e4840af6f750d4300e7444.svg";
export { ForwardRef as ReactComponent };